import { getSubtotal } from "@analytics/klaviyo/utils/getTotals";

import { Product } from "@typings/product/product";

export const getShippingCost = (cartItems: Product[]): number => {
  const subscriptionOffer = cartItems.find(
    (i) => i.configuration.offer.name === "Monthly Subscription"
  );

  if (subscriptionOffer) return 0;

  return getSubtotal(cartItems) < 40 ? 4.99 : 0;
};
